import { getApi, postApi, putApi } from 'apis';

const getAllMidMonthPays = async (params: any) => {
	return await getApi('/mid-month-pay', params);
};

const updateMidMonthPayStatus = async (id: string, data: any) => {
	return await putApi(`/mid-month-pay/${id}`, data);
};

const regenerateCsv = async (body: any) => {
	return await postApi(`/mid-month-pay/csv-re-generate`, body);
};

const getEmployeeDetailsForMidMonth = async (midMonthId: string) => {
	return await postApi('/mid-month-pay/employee-details', { midMonthId });
};

const proceedToMidMonthPaymentForFCB = async (data: any) => {
	return await postApi('/mid-month-pay/initiate-payment', data);
};

const getBankDetailsForMidMonthDetails = async (data: {
	employeeId: string;
}) => {
	return await postApi('/mid-month-pay/bank-details', data);
};

const getEmployeePaymentHistory = async (data: {
	midMonthId: string;
	employeeId: string;
}) => {
	return await getApi('/mid-month-pay/employee-payment-history', data);
};

const getPaymentLogs = async (data: { midMonthId: string }) => {
	return await getApi('/mid-month-pay/payment-logs', data);
};

export const midMonthPayApi = {
	getAllMidMonthPays,
	updateMidMonthPayStatus,
	regenerateCsv,
	getBankDetailsForMidMonthDetails,
	getEmployeeDetailsForMidMonth,
	proceedToMidMonthPaymentForFCB,
	getPaymentLogs,
	getEmployeePaymentHistory,
};
